import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GTMBaseContentViewObject, PageTracker } from '../../hooks/GTMUtils';
import { Heading } from '../Heading';

export const NoAvailableCountryMarket: FC = () => {
  const [t] = useTranslation();

  return (
    <PageTracker
      gtmTrackingData={{
        ...GTMBaseContentViewObject,
        data: {
          category: 'User Area',
          type: 'Select Market/User',
          content: 'No country/market',
        },
      }}
    >
      <div className="flex flex-col justify-center h-full mx-5 text-center">
        <Heading
          text={t('components:noCountryMarketAvailable:heading')}
          align="center"
        />
        <p>{t('components:noCountryMarketAvailable:body')}</p>
      </div>
    </PageTracker>
  );
};
